import { Download } from "lucide-react";
import { PageHeader } from "../components/admin/PageHeader";
import { ReviewTable } from "../components/admin/ReviewTable";
import { adminDownload } from "../components/admin/adminApi";

export function ReviewsPage({ focus }: { focus?: string }) {
  return (
    <div className="wr-page wr-reviews-page">
      <PageHeader
        eyebrow={focus === "moderation" ? "Moderation desk" : "Review library"}
        title={focus === "moderation" ? "Moderation" : "Manage reviews"}
        description="Search, filter, publish, reject, reply, feature, export, and inspect audit history."
        meta={
          <>
            <span>Verified-buyer controls</span>
            <span>Reply and feature workflow</span>
            <span>CSV export ready</span>
          </>
        }
        action={
          <button className="wr-button" type="button" onClick={() => void adminDownload("/api/admin/exports/reviews.csv", "whatstar-reviews.csv")}>
            <Download size={15} aria-hidden />
            Export CSV
          </button>
        }
      />
      <ReviewTable focus={focus} />
    </div>
  );
}
